import Vue from "vue";
import Router from "vue-router";
import HomeView from "../views/HomeView.vue";
import AboutView from "../views/AboutView.vue";

Vue.use(Router);

const COMPANY = "POSITIVE UP PTE. LTD.";

const router = new Router({
  mode: "hash",
  routes: [
    {
      path: "/",
      name: "home",
      component: HomeView,
      meta: { title: COMPANY + " | Singapore" }
    },
    {
      path: "/about",
      name: "about",
      component: AboutView,
      meta: { title: "About Us | " + COMPANY }
    }
  ]
});

router.afterEach((to) => {
  if (to.meta && to.meta.title) {
    document.title = to.meta.title;
  }
});

export default router;
